/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  showActionButton: PropTypes.bool,
  buttonAction: PropTypes.func,
  buttonLabel: PropTypes.string
};

const defaultProps = {
  className: '',
  label: '',
  showActionButton: false,
  buttonAction: () => {},
  buttonLabel: ''
};

const Banner = (props) => {
  let { className, label, showActionButton, buttonAction, buttonLabel } = props;

  return (
    <div id="crf-banner-container" className={`crf-banner ${className}`}>
      <p id="crf-banner-message">{label}</p>
      {showActionButton && (
        <span id="crf-banner-action-container">
          <button id="crf-banner-button" type="button" className="btn btn-blue" onClick={buttonAction}>
            {buttonLabel}
          </button>
        </span>
      )}
    </div>
  );
};

Banner.defaultProps = defaultProps;
Banner.propTypes = propTypes;

export default Banner;
